import { render } from "./Paginate.vue?vue&type=template&id=72c4ba2f&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=72c4ba2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c4ba2f"]])

export default __exports__